// project-imports
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { ToastContainer } from 'react-toastify';
import { ConfigProvider } from 'antd';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
  <ConfigProvider
    theme={{
      components: {
        Input: {
          colorBgContainer: '#fff', // Input background color
          colorBorder: '#D6E4FF', // Input border color
          colorText: 'rgb(244, 3, 20)',
          activeBorderColor: '#D6E4FF',
          colorBgContainerDisabled: '#F5F5F5', // Disabled background color
          colorTextDisabled: '#000', // Disabled text color
          colorBorderDisabled: '#D9D9D9', // Disabled border color
        },
        Select: {
          colorBgContainer: '#fff', // Select background color
          colorBorder: '#D6E4FF', // Select border color
          colorText: 'rgb(244, 3, 20)',
          activeBorderColor: '#D6E4FF',
          colorBgContainerDisabled: '#F5F5F5', // Disabled background color
          colorTextDisabled: '#000', // Disabled text color
          colorBorderDisabled: '#D9D9D9', // Disabled border color
          colorItemTextDisabled: '#BFBFBF', // Disabled dropdown item text color
        },
      },
      token: {
        // Seed Token
        colorPrimary: 'rgb(244, 3, 20)',
        colorBorder: '#D6E4FF',
        // Alias Token
      },
    }}
  >
    <ThemeCustomization>
      <ScrollTop>
        <Routes />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          // theme="black"
          progressStyle={{ background: 'rgb(244, 3, 20)', height: '4px' }}
        />
      </ScrollTop>
    </ThemeCustomization>
  </ConfigProvider>
);

export default App;
